import { Component, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { ConfirmationConstructor } from '../../services/notification.service';

@Component({
	selector: 'pk-broker-notification-modal',
	templateUrl: './notification-modal.component.html',
	styleUrls: ['./notification-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class NotificationModalComponent {
	// inputs
	public title: string;
	public body: string;
	public body2: string;
	public confirmationType: ConfirmationConstructor;
	public customConfirmationButtonText = 'Confirm';
	public confirmButtomClass = 'btn btn-primary';
	public cancelButtonClass = 'btn btn-link';

	// outputs
	public onConfirm: EventEmitter<boolean> = new EventEmitter();
	public onCancel: EventEmitter<boolean> = new EventEmitter();

	constructor(private activeModal: BsModalRef) {}

	get isConfirm(): boolean {
		return this.confirmationType === 'confirm';
	}

	get isYesNo(): boolean {
		return this.confirmationType === 'yesNo';
	}

	get isOk(): boolean {
		return this.confirmationType === 'ok';
	}

	public close(): void {
		this.activeModal.hide();
	}

	public confirm(): void {
		this.onConfirm.emit(true);
		this.close();
	}

	public cancel(triggerClose = true): void {
		this.onCancel.emit(true);
		if (triggerClose) {
			this.close();
		}
	}
}
